<script>

export default {
    name: 'HistoryModal',
    props:[
        "data"
    ],
    data() {
        return {
            dataList: [],
            url: '',
            title: ''
        }
    },
    watch:{
        data(props){
            this.title = 'Son 50 Arıza Geçmişi'
            this.url = props.url
            this.dataList = []
            this.loadItems()
        }
    },
    methods: {
        loadItems(){
            this.$http.post(this.url)
                  .then(resp => {
                      this.dataList = resp.data.data
                  })
        },
        close(){
            this.$parent.$bvModal.hide('gecmis_arizalari')
        }
    },
};
</script>

<template>
  <b-modal id="gecmis_arizalari" size="xl" :title="title"  no-close-on-backdrop hide-footer>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <table class="table table-hover"> 
                    <thead>
                        <tr>
                            <th>Başlığı</th>
                            <th style="width:70%">Açıklaması</th>
                            <th>Atanan</th>
                            <th>Açılma Tarihi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(list,i) in dataList" :key="i">
                            <td>{{ list.subject }}</td>
                            <td>{{ list.content }}</td>
                            <td>{{ list.assigned_name }}</td>
                            <td>{{ list.date_format }}</td>   
                        </tr>
                        <tr v-if="dataList.length ==0">
                            <td class="text-center" colspan="4">Henüz Kayıt Bulunmuyor</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</b-modal>
</template>